import '../../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import karmaStyles from '../../../../styles/KarmaPool.module.css'
import { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';
import { Paper, Grid } from '@mui/material';

function UnselectedUnavailableTag(props) {
    return (
        <Typography variant="body2" component="div" gutterBottom sx={{
            display: "inline-block",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.425rem",
            margin: "0.125rem",
            width: "100%",
            color: "rgba(221, 221, 221, 0.375)",
        }}>
            {props.tagName} ({props.count})
        </Typography>
    );
}

function UnselectedTag(props) {
    return (
        <Typography variant="body2" component="div" gutterBottom sx={{
            display: "inline-block",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.425rem",
            width: "100%",
            margin: "0.025rem",
        }}>
            {props.tagName} ({props.count})
        </Typography>
    );
}

function SelectedTag(props) {
    return (
        <Typography variant="body2" component="div" gutterBottom sx={{
            display: "inline-block",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.425rem",
            width: "100%",
            margin: "0.125rem",
        }}>
            <strong> {props.tagName} ({props.count}) </strong>
        </Typography>
    );
}


function TextTagComponent(props) {
    const { selected, count } = props;

    if (selected) return <SelectedTag {...props} />;
    return count === 0 ? <UnselectedUnavailableTag {...props} /> : <UnselectedTag {...props} />;
}

function TagComponent(props) {
    return (
        <Box sx={{ display: "fixed", justifyContent: "center", alignItems: "center", minWidth: props.width }}>
            <Link href="#" onClick={(event) => props.onClick(event, props.tagName)}
                underline="hover">
                <TextTagComponent {...props} />
            </Link>
        </Box>
    );
}

export default TagComponent;